var _circle, _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#111827"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 173,
    width: 103,
    height: 14,
    rx: 7,
    fill: "#1E263B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 122,
    width: 43,
    height: 14,
    rx: 7,
    transform: "rotate(90 135 122)",
    fill: "#4C5876"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 122,
    width: 43,
    height: 14,
    rx: 7,
    transform: "rotate(90 164 122)",
    fill: "#4C5876"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 122,
    width: 43,
    height: 14,
    rx: 7,
    transform: "rotate(90 106 122)",
    fill: "#4C5876"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.346 71.654C126.97 70.6421 129.028 70.6455 130.649 71.6627L181.789 103.765C186.039 106.433 184.149 113 179.13 113L76.4771 113C71.4502 113 69.5664 106.415 73.8326 103.756L125.346 71.654Z",
    fill: "#1E263B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.179f4b81bee3197e61fe79972525c342.svg";
export { ForwardRef as ReactComponent };